export default __webpack_public_path__ + "static/Entenda0127-081931c132e2dc3d24793b461213d5e8.jpg";